<template>
  <ServiceList/>
</template>

<script setup lang="ts">
// Городской адрес узла каталога: `/uslugi/{город}/{узел}/`. Город стоит вторым сегментом по
// образцу врачей и клиник, раздел остаётся первым.
definePageMeta({
  path: '/uslugi/:segment([a-z-0-9_]+)/:node([a-z-0-9_]+)',
})
</script>
